export const getPersonName = (channelName?: string | null): string =>
    (channelName ?? '').replace(/\s*\([^)]*\)\s*$/, '').trim();
